const thumbClass = 'thumblist-item';
const mytap = window.ontouchstart === null?"touchstart":"click";

const mySwiper = new Swiper('.slider', {
  speed: 1500,
  pagination:{
    el:'.thumblist',
    type:'custom',
    renderCustom: function (swiper, current, total) {
      const slides = swiper.slides;
      let html = '';
      for( let i = 0 ; i < total; i++ ){
        if( current == i+1 ){
          html = html + `<div class="${thumbClass} current" data-slideto="${i}">${slides[i].innerHTML}</div>`;
        }else{
          html = html + `<div class="${thumbClass}" data-slideto="${i}">${slides[i].innerHTML}</div>`;
        }
      }
      return html;
    }
  }
});

const clickThumbs = (()=>{
  const thumbItems = document.getElementsByClassName(thumbClass);
  for(let i = 0; i < thumbItems.length ; i ++){
    thumbItems[i].addEventListener(mytap,((e)=>{
      let index = e.currentTarget.dataset.slideto;
      mySwiper.slideTo(index, 800, true);
    }),false);
  }
});

clickThumbs();
mySwiper.on('slideChange',clickThumbs);

const swiper = new Swiper(".top-eyecatch__slider", {
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 5,
  speed: 500,
  autoplay: {
    delay: 3000,
  },
  centeredSlides: true,
  preventClicks: true,
  simulateTouch: false,
  breakpoints:{
    750: {
      slidesPerView: 1.8,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    }
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const recommend_swiper = new Swiper(".recommend-product__slider", {
  loop: false,
  slidesPerView: 2.5,
  spaceBetween: 15,
    freeMode: {
      enabled: true,
      momentumRatio: 0.3,
      momentumVelocityRatio: 0.35,
    },
});

const ranking_swiper = new Swiper(".ranking-product__slider", {
  loop: false,
  slidesPerView: 2.5,
  spaceBetween: 15,
  freeMode: {
      enabled: true,
      momentumRatio: 0.3,
      momentumVelocityRatio: 0.35,
    },
});

const pickup_swiper = new Swiper(".pickup-product__slider", {
  loop: false,
  slidesPerView: 2.5,
  spaceBetween: 15,
    freeMode: {
      enabled: true,
      momentumRatio: 0.3,
      momentumVelocityRatio: 0.35,
    },
});

const recently_viewed_swiper = new Swiper(".recently-viewed__slider", {
  loop: false,
  slidesPerView: 4.5,
  spaceBetween: 15,
    freeMode: {
      enabled: true,
      momentumRatio: 0.3,
      momentumVelocityRatio: 0.35,
    },
});